import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-17/task-02";

const task: Slide = {
  titleHtml:
    "The on-axis sensitivity in the bandwidth of the cardoid<br>microphone presented in this lesson depends on the:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
